<template>
  <div class="view_error">
    <div class="view_error__main">
      <span class="view_error__icon">
        <slot name="icon">
          <template v-if="status === 404">🤷‍♂️</template>
          <template v-else>🔒</template>
        </slot>
      </span>
      <h1>{{ title || defaultTitle }}</h1>
      <template v-if="errorCode">
        <p v-if="reason">
          <strong>{{ reason || "" }}</strong>
        </p>
        <p v-if="explanation">{{ explanation }}</p>
      </template>

      <slot></slot>
    </div>
    <slot name="backlink">
      <router-link :to="{ name: 'models-explorer' }">{{
        $t("labels.backToModels")
      }}</router-link>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = withDefaults(defineProps<{
  errorCode?: string;
  title?: string;
  status?: number;
}>(), {
  status: 403
});

const { te, t } = useI18n({ useScope: "global" });

const defaultTitle = computed(() => {
  if (props.status === 404) return t("errors.pageNotFound");
  if (props.status === 403) return t("errors.forbidden");
  return t("words.error");
});
const reason = computed(() => {
  // this.$t("errors.apiExceptions.no_active_subscription")
  // this.$t("errors.apiExceptions.publication_expired")
  if (!te(`errors.apiExceptions.${props.errorCode}`)) return null;
  return t(`errors.apiExceptions.${props.errorCode}`);
});
const explanation = computed(() => {
  // this.$t("errors.apiExceptionDetails.no_active_subscription")
  // this.$t("errors.apiExceptionDetails.publication_expired")
  if (!te(`errors.apiExceptionDetails.${props.errorCode}`)) return null;
  return t(`errors.apiExceptionDetails.${props.errorCode}`);
});
</script>

<style lang="scss">
.view_error {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &__icon {
    font-size: 1.5rem;
  }

  &__main {
    padding: 2rem;
    text-align: center;
    max-width: 42rem;
    
    h1 {
      pointer-events: all;
      user-select: auto;
    }
  }
}
</style>
